import { getProvider } from '@/apollo'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'

const EmailConfirmationModule = {
  namespaced: true,
  state: {
    view: 'confirmBirthdate',
    emailConfirmToken: null,
    solicitorId: null,
    requested: null
  },
  actions: {
    confirmBirthdate ({ commit, state, rootGetters }, { birthdate, nextStep = 'success' }) {
      const apolloClient = getProvider().defaultClient

      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation confirmEmailVerification ($input: ConfirmEmailVerificationInput!){
          confirmEmailVerification (confirmEmailVerificationInput: $input) {
            success
          }
        }`,
        variables: {
          input: {
            token: state.emailConfirmToken,
            brand: rootGetters.brand,
            solicitorId: state.solicitorId,
            birthdate: birthdate
          }
        }
      }).then((response) => {
        commit('Transaction/removeTransactionId', 'confirmEmailVerification', { root: true })
        if (response.data.confirmEmailVerification.success) {
          state.view = nextStep
        }
        return response
      }).catch((error) => {
        let message = 'error'
        splitError(error).forEach(e => {
          if (e.extensions.magma_code === 1015) {
            message = 'birthdateInvalid'
          } else {
            if (e.extensions?.category === 'graphql') {
              commit('addError', 'Es ist ein technischer Fehler aufgetreten.', { root: true })
            } else {
              commit('addError', e, { root: true })
            }
            state.view = 'error'
          }
        })
        return message
      })
    },
    switchView (state, view = 'confirmBirthdate') {
      state.view = view
    }
  },
  mutations: {
    captureEmailConfirmationParameter (state, param) {
      if (param.token && param.solicitorId) {
        state.emailConfirmToken = param.token
        state.solicitorId = param.solicitorId
      } else {
        state.emailConfirmToken = null
        state.solicitorId = null
      }
    },
    switchView (state, view) {
      state.view = view
    },
    setRequested (state, dt) {
      state.requested = dt
    }
  },
  getters: {
    urlParametersValid: state => {
      return state.emailConfirmToken?.length > 0 && state.solicitorId?.length > 0
    },
    getView: state => {
      return state.view
    },
    requested: state => {
      return state.requested
    }
  }
}

export {
  EmailConfirmationModule
}
